<script>
  import Login from '../Login.svelte';
  import { user, selectedChannelId } from '../../Store/store';
  import Channels from './Channels/Channels.svelte';
  import Settings from './Settings/Settings.svelte';
  import { Tabs, TabList, TabPanel, Tab } from '../Common/Tabs';
  import Profile from './Profile/Profile.svelte';
</script>

<div class="container">
  {#if $user}
    <div class="sidebar">
      <Channels />
    </div>
    <div class="workspace">
      {#if $selectedChannelId}
        <div class="workspace-container">
          <div class="tabs-container">
            <Tabs>
              <div class="tab-list">
                <TabList>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> list </span>
                      <span>Innhold</span>
                    </div>
                  </Tab>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> settings </span>
                      <span>Innstillinger</span>
                    </div>
                  </Tab>
                </TabList>
              </div>
              <TabPanel>
                <Profile />
              </TabPanel>
              <TabPanel>
                <Settings />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      {:else}
        <div class="empty">
          <p>Opprett en sportsprofil</p>
        </div>
      {/if}
    </div>
  {:else}
    <Login />
  {/if}
</div>

<style src="./profiles.scss"></style>
